import React from 'react';
import {TableCell, TableRow, Typography} from '@mui/material';
import {IDateHeaderProps} from './types';
import {convertGermanStringToDate, DAYS_LIST} from './utils';

const DateHeader: React.FC<IDateHeaderProps> = ({dateStr}) => (
    <TableRow
        sx={{
            '& > *': {borderBottom: 'unset'},
            backgroundColor: 'rgba(25, 118, 210, 0.04)',
            '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
            },
            transition: 'background-color 0.2s',
        }}>
        <TableCell>
            <Typography variant='subtitle1' fontWeight={600} color='primary'>
                {DAYS_LIST[convertGermanStringToDate(dateStr).getDay()] + ', ' + dateStr}
            </Typography>
        </TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
    </TableRow>
);

export default React.memo(DateHeader);
